module.exports = __webpack_public_path__ + "static/media/socioterapia.b2a8959a.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/content/devdata/resources/exhibitors/socioterapia.jpeg
// module id = 517
// module chunks = 0